import styled, { css } from 'react-emotion'
import { spacer, color, typography } from 'stylist'
import { Link } from 'react-router-dom'

const header = ({ theme, header }) =>
  header &&
  css`
    padding: ${spacer(3, { theme })} ${spacer(4, { theme })};
    color: ${color('cadet', { theme })};
    ${typography('body1', { theme })};
  `

const actions = ({ actions, theme }) =>
  actions &&
  css`
    justify-content: end;
    grid-gap: ${spacer(2, { theme })};
  `

const justify = ({ justify }) =>
  justify &&
  css`
    justify-content: ${justify};
  `

const width = ({ width }) =>
  width &&
  css`
    width: ${width};
  `

const ListRow = styled.div`
  display: grid;
  grid-gap: ${spacer(4)};
  grid-template-columns: ${({ templateColumns }) => templateColumns};

  ${header};
`

const Cell = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;

  ${actions};
  ${width};
  ${justify};
`

const TitleLink = styled(Link)`
  &:hover {
    text-decoration: underline;
  }
`

ListRow.Cell = Cell
ListRow.TitleLink = TitleLink

export default ListRow



// WEBPACK FOOTER //
// ./src/components/ListRow.js